import React from 'react';
import { withRouter } from 'react-router-dom';

export class DataErasurePage extends React.Component {
  render() {
    return (
      <div
        id="page-container"
        className="row align-items-center justify-content-center">
        <div className="col-lg-6">
          <div id="root-privacy-container" className="col-lg-12 text-center">
            <h3 className="modal-title">
              Data Erasure
            </h3>

            <br/>

            <div>
              If you wish to request that all personal data we hold for your account be deleted,
              please send the request to: <a href="mailto:myadmin@myhellohello.com">myadmin@myhellohello.com</a>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DataErasurePage);


// WEBPACK FOOTER //
// ./src/components/pages/DataErasurePage/DataErasurePage.jsx